import { IProductionLine } from "entities/ProductionLines/ProductionLinesInterfaces";
import { IDivision } from "./CorporationForm/CorporationFormInterfaces";

export interface IUserCorporateAdmin {
    user_id?: number;
    first_name: string;
    last_name: string;
    email: string;
    user_type: {
        name: string;
        default_user_type_translations: {
            user_type_id: number;
            language: {
                language_id: number;
                name: string;
                code: string;
            };
            translated_name: string;
        }[];
    };
    is_enabled: boolean;
}
export interface ICorporation {
    corporate_id: number;
    name: string;
    address_1: string;
    address_2: string;
    city_id: number;
    country_id: number;
    mills?: IMill[];
    users: IUserCorporateAdmin[];
    created_at: Date;
    phone_number: string;
    city_name: string;
    state_name: string;
    state_id: number;
    rca_enabled: boolean;
    corporate_dashboard_enabled: boolean;
    corporate_module_licenses: {
        expires_at: Date;
        is_enabled?: boolean;
        module_license: {
            module_license_id: number;
            name: string;
        };
    }[];
    media?: {
        media_id: number;
        media_url: string;
    };
    zip_code: string;
    divisions?: IDivision[];
}

export interface ICountry {
    id: number;
    name: string;
    code?: string;
    numeric_code: string;
}

export interface IState {
    id: number;
    name: string;
    country_id: number;
}

export interface ICity {
    id: number;
    name: string;
    state_id: number;
}
export interface ISelectOption {
    code: string;
    name: string;
}

export interface ICreateCorporationResponse {
    status: number;
}

export interface IMill {
    mill_id: number;
    name?: string;
    code?: null;
    cluster_enabled: boolean;
    dedicated_localserver?: boolean;
    mill_modules?: { module_type_id: number; is_enabled: boolean }[];
    country?: {
        id?: number | string;
        name: string;
        code: string;
    };
    is_enabled?: boolean;
    physical_address?: string;
    physical_address_2?: string;
    physical_state_name?: string;
    physical_city_name?: string;
    physical_zip_code?: string;
    physical_country_id?: number;
    billing_address?: string;
    billing_address_2?: string;
    billing_state_name?: string;
    billing_city_name?: string;
    billing_zip_code?: string;
    billing_country_id?: number;
    url?: string;
    phone_number?: string;
    naics_code?: number;
    created_at?: Date;
    corporate_id?: number;
    division_id?: number;
    region_id?: number;
    mill_data: {
        language_id: number;
        first_day_reporting_week: number;
        day_reporting_week?: {
            day_id: number;
            name: string;
            default_day_translations: {
                default_day_translation_id: number;
                language: {
                    language_id: number;
                    name: string;
                };
                translated_name: string;
            }[];
        };
        measure_metric_id: number;
        first_day_fiscal_year?: null;
        timezone?: string;
        language?: {
            language_id?: number;
            name?: string;
        };
    };
    corporate?: {
        corporate_data?: {
            url?: string;
        };
    };
    division?: {
        division_id?: number;
        name?: string;
    };
    region?: {
        region_id?: number;
        name?: string;
    };
    crews: { crew_id: number; name: string }[];
    mill_key_success_factors: {
        is_enabled?: boolean;
        key_success_factor: { corporate_id?: number; key_success_factors_id: number; name: string };
    }[];
    shifts: {
        name?: string;
        shift_id: number;
        shift_historic: {
            shift_historic_id: number;
            end_time: string;
            start_time: string;
            shift_days: {
                day_id: number;
                is_enabled: boolean;
                day?: {
                    day_id: number;
                    name: string;
                    default_day_translations?: {
                        default_day_translation_id: number;
                        language: {
                            language_id: number;
                            name: string;
                        };
                        translated_name: string;
                    }[];
                };
            }[];
        }[];
    }[];
    users?: {
        user_id: number;
        first_name: string;
        last_name: string;
        email?: string;
        user_type_id?: number;
    }[];
    production_lines?: IProductionLine[];
}

export enum StepsEnum {
    corporationSetup,
    millSetup,
}
